// Função para verificar se um produto é Gift Card
export const isGiftCard = (productId: string) => productId === '11113'
